export default "__VITE_ASSET__J6nbz$fe__"